import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/blattbild.de/kalender.blattbild.de/cal.com/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
